<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 1rem">
      <van-cell-group inset>
        <van-sticky>
          <van-field v-model="form.code" name="code" label="采购收货单号" />
          <van-cell @click="showStockSelect" clickable>
            <van-field
              v-model="form.scName"
              inputmode="none"
              name="scName"
              label="仓库"
              @click-right-icon="(e) => clearField(e, form, 'scName', ['scId'])"
            ></van-field>
          </van-cell>
          <van-cell @click="showSupplierSelect" clickable>
            <van-field
              v-model="form.supplierName"
              name="supplierName"
              inputmode="none"
              label="供应商"
              @click-right-icon="(e) => clearField(e, form, 'supplierName', ['supplierId'])"
            ></van-field>
          </van-cell>
          <van-cell>
            <van-button :loading="loading" type="primary" @click="search"
              >查询</van-button
            >
          </van-cell>
        </van-sticky>
      </van-cell-group>
      <div class="tableBox">
        <CustomTable
          ref="table"
          :scrollWidth="600"
          :columns="columns"
          :tableData="tableData"
          @selectedRowChange="showActive"
          :total="totalCount"
          :pageIndex="pageIndex"
          :pageSize="pageSize"
          @pageChange="pageChange"
        ></CustomTable>
      </div>
      <StockSelect
        :visible="stockSelectVisible"
        @confirm="stockSelectConfirm"
      ></StockSelect>
      <SupplierSelect
        :visible="supplierSelectVisible"
        @confirm="supplierSelectConfirm"
      ></SupplierSelect>
    </van-form>
    <!-- <van-cell style="position: absolute;bottom:0;">
      <van-button round block type="primary" @click="confirm">
        提交
      </van-button>
    </van-cell> -->
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { queryWithReturn } from "../service/api/purchase/receive";
import StockSelect from "./stockSelect.vue";
import SupplierSelect from "./supplierSelect.vue";
import CustomTable from "./customTable.vue";
// 导入样式
export default {
  name: "receiveSheetSelect",
  components: {
    StockSelect,
    SupplierSelect,
    CustomTable,
  },
  props: {
    visible: false,
  },
  data() {
    return {
      supplierSelectVisible: false,
      stockSelectVisible: false,
      loading: true,
      show: false,
      data: [],
      form: { code: "", name: "", status: 3 },
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPage: 1,
      columns: [
        {
          field: "name",
          key: "b",
          // type=radio
          type: "radio",
          title: "单选",
          width: 30,
          align: "left",
        },
        { width: 100, field: "code", key: "code", title: "采购收货单号" },
        { width: 100, field: "scCode", key: "scCode", title: "仓库编号" },
        { width: 100, field: "scName", key: "scName", title: "仓库名称" },
        {
          width: 100,
          field: "supplierCode",
          key: "supplierCode",
          title: "供应商编号",
        },
        {
          width: 100,
          field: "supplierName",
          key: "supplierName",
          title: "供应商名称",
        },
        {
          width: 100,
          field: "createTime",
          key: "createTime",
          title: "操作时间",
        },
        { field: "createBy", key: "createBy", title: "操作人" },
      ],
      tableData: [],
      statusList: AVAILABLE,
      categoryList: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.unselectedAll();
      });
    },
  },
  created() {
    this.search();
  },
  methods: {
   
    showStockSelect() {
      this.stockSelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.form.scName = row.name;
      this.form.scId = row.id;
    },
    showSupplierSelect() {
      this.supplierSelectVisible = true;
    },
    supplierSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.supplierSelectVisible = false;
        return;
      }
      this.supplierSelectVisible = false;
      this.form.supplierName = row.name;
      this.form.supplierId = row.id;
    },
    search() {
      this.getProductList();
      // this.categoryList = this.data.filter((el) => {
      //
      //   return el.code.includes(this.form.code)&&el.name.includes(this.form.name)
      // });
    },
    showActive(item) {
      this.currentRow = item;
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;
      this.getProductList();
    },
    getProductList() {
      this.loading = true;
      const params = Object.assign({}, this.form, {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
      queryWithReturn(params).then((res) => {
        this.tableData = res.data.datas;
        this.loading = false;
        this.totalCount = res.data.totalCount;
        this.totalPage = res.data.totalPage;
        this.pageSize = res.data.pageSize;
        this.pageIndex = res.data.pageIndex;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 85%;
}
// .van-cell_title {
//   color: #333;
//   font-size: 12px;
// }
::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}
.tableBox {
  height: calc(100vh - 333px);
  overflow-y: auto;
}
.scrollList {
  height: calc(100% - 185px) !important;
  overflow: auto;
}

::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
